import {useState} from 'react';

import {Box, useTheme, Button} from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';

import DeleteAlert from 'components/alerts/DeleteAlert';

import useParseURL from 'hooks/useParseURL';
import deleteRedirectHandler from 'helpers/deleteRedirectHandler';
import {useInputMenuContext} from 'context/InputMenu';
import * as I from 'interfaces';
import {mutate} from 'swr';
import {useTranslation} from 'react-i18next';
import useGetLongTermRange from 'hooks/useGetLongTermRange';
import {useGetFilteredSites} from 'hooks/useGetFilteredSites';

const DeleteActionButtons = () => {
  const theme = useTheme();
  const {t} = useTranslation('common');

  const [openDeleteAlert, setOpenDeleteAlert] = useState<boolean>(false);
  const {pathname, urlSearchParams, navigate, planId, siteId, cageId} = useParseURL();

  const inputContext = useInputMenuContext();
  const inputMenuState = inputContext?.state;
  const {startDate, endDate} = useGetLongTermRange();
  const {data: filteredSites} = useGetFilteredSites({planId, pathname});
  const filteredSiteNames = (filteredSites ?? []).map(({name}) => name);

  const getId = () => {
    switch (inputMenuState?.form) {
      case I.FormSelectionEnum.plan:
        return planId;
      case I.FormSelectionEnum.site:
        return inputMenuState?.formData?.id ?? siteId;
      case I.FormSelectionEnum.cage:
        return inputMenuState?.formData?.id ?? cageId;
      default:
        return inputMenuState?.formData?.id;
    }
  };
  const id = getId();

  const handleCommunicationSucces = () =>
    startDate &&
    endDate &&
    deleteRedirectHandler({
      type: inputMenuState?.form,
      navigate,
      pathname,
      urlSearchParams,
      planId,
      siteId,
      cageId,
      mutate,
      formData: inputMenuState?.formData,
      startDate,
      endDate,
      filteredSites: filteredSiteNames,
    });

  return (
    <>
      {id && inputMenuState?.form && (
        <DeleteAlert
          open={openDeleteAlert}
          setOpen={setOpenDeleteAlert}
          id={id}
          type={inputMenuState?.form}
          handleCommunicationSucces={handleCommunicationSucces}
        />
      )}
      <Box display="flex" justifyContent="center">
        <div style={{width: '100%'}}>
          <Box display="flex" justifyContent="space-between">
            <Box width="45%">
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  setOpenDeleteAlert(true);
                }}
                endIcon={<DeleteIcon />}
                fullWidth={true}
                data-testid="delete-button"
              >
                {t('delete')}
              </Button>
            </Box>
            <Box width="45%">{t('removeAction')}</Box>
          </Box>
        </div>
      </Box>
    </>
  );
};

export default DeleteActionButtons;
